module.exports = __webpack_public_path__ + "img/thumb_chestnut_montage.98fdd542.png";